(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-butter-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jb-butter-videos')) {
  customElements.define('jb-butter-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.videos = Array.from(this.querySelectorAll('video'));
      this.autoStopped = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const load = video => {
        if (!video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.load();
        }
      };
      this.videos.forEach(video => {
        const card = video.closest('article');
        const toggle = card.querySelector('[data-toggle]');
        const sound = card.querySelector('[data-sound]');
        const sync = () => {
          const label = video.paused ? this.dataset.play : this.dataset.pause;
          toggle.querySelector('[data-toggle-label]').textContent = label;
          toggle.setAttribute('aria-label', label + ': ' + video.getAttribute('aria-label'));
          sound.textContent = video.muted ? this.dataset.soundOn : this.dataset.soundOff;
          sound.setAttribute('aria-label', sound.textContent);
        };
        video.muted = true;
        toggle.addEventListener('click', () => {
          load(video);
          if (video.paused) {
            if (!video.hasAttribute('data-auto')) video.muted = false;
            video.play().catch(sync);
          } else {
            if (video.hasAttribute('data-auto')) this.autoStopped = true;
            video.pause();
          }
        }, { signal });
        sound.addEventListener('click', () => {
          video.muted = !video.muted;
          sync();
        }, { signal });
        video.addEventListener('play', () => {
          this.videos.forEach(other => { if (other !== video) other.pause(); });
          if (!video.hasAttribute('data-auto')) this.autoStopped = true;
          sync();
        }, { signal });
        ['pause', 'ended', 'volumechange'].forEach(event => video.addEventListener(event, sync, { signal }));
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
            if (video.hasAttribute('data-auto') && !this.autoStopped && !this.reduceMotion.matches && !navigator.connection?.saveData && !document.hidden) {
              load(video);
              video.play().catch(() => {});
            }
          } else video.pause();
        });
      }, { threshold: [0, 0.45] });
      this.videos.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, { signal });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.videos?.forEach(video => video.pause());
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-cart"]) return;
  try {
    
(()=>{
 const init=()=>{
 const form=document.getElementById('JBCartForm');if(!form)return;
 const note=form.querySelector('[name="note"]'),start='[Buy 4 Get 4 selections]',end='[/Buy 4 Get 4 selections]';
 const a=note.value.indexOf(start),b=note.value.indexOf(end);let saved=[];
 if(a>=0&&b>a){saved=note.value.slice(a+start.length,b).trim().split('\n');note.value=(note.value.slice(0,a)+note.value.slice(b+end.length)).trim();}
 const rows=[...form.querySelectorAll('[data-gift-row]')];
 const available=saved.map(line=>{const split=line.lastIndexOf(' — ');return {scent:line.slice(0,split),usage:line.slice(split+3)};});
 rows.forEach(row=>{const select=row.querySelector('[data-gift-choice]'),usage=row.querySelector('[data-gift-usage]').value;const i=available.findIndex(item=>item.usage===usage&&[...select.options].some(o=>o.value===item.scent));if(i>=0){select.value=available[i].scent;available.splice(i,1);}});
 form.addEventListener('submit',()=>{
  const lines=[];
  form.querySelectorAll('[data-gift-group]').forEach(group=>{
   const usage=group.dataset.giftGroup;
   const paid=[...form.querySelectorAll('[name="updates[]"]')].filter(input=>input.dataset.product==='7891332399197'&&input.dataset.usage===usage).reduce((sum,input)=>sum+Math.max(0,Math.floor(Number(input.value)||0)),0);
   const allowed=Math.floor(paid/4)*4;
   [...group.querySelectorAll('[data-gift-row]')].slice(0,allowed).forEach(row=>{const scent=row.querySelector('[data-gift-choice]').value;if(scent)lines.push(scent+' — '+usage);});
  });
  const text=note.value.replace(/\[Buy 4 Get 4 selections\][\s\S]*?\[\/Buy 4 Get 4 selections\]/g,'').trim();note.value=text+(lines.length?'\n\n'+start+'\n'+lines.join('\n')+'\n'+end:'');
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-policy"] && !Shopify.designMode) return;
  try {
    
function initJerseyPolicy(){document.querySelectorAll('.jb-policy').forEach(root=>{const links=root.querySelector('[data-policy-links]');if(!links||links.children.length)return;root.querySelectorAll('.jb-pl-body h2,.jb-pl-body h3').forEach((heading,i)=>{if(!heading.id)heading.id='jb-policy-section-'+i;const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;links.appendChild(link)});if(!links.children.length)root.querySelector('.jb-pl-nav').hidden=true})}initJerseyPolicy();document.addEventListener('shopify:section:load',initJerseyPolicy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-privacy"] && !Shopify.designMode) return;
  try {
    
function initJerseyPrivacy(){document.querySelectorAll('.jb-privacy').forEach(root=>{const links=root.querySelector('[data-privacy-links]');if(!links||links.children.length)return;root.querySelectorAll('.jb-pr-body h2').forEach((heading,i)=>{if(!heading.id)heading.id='jb-privacy-section-'+i;const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;links.appendChild(link)});if(!links.children.length)root.querySelector('.jb-pr-nav').hidden=true})}initJerseyPrivacy();document.addEventListener('shopify:section:load',initJerseyPrivacy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
